<template>
  <div class="page-wrapper">
    <!-- Modal -->
    <div
      id="addalarm"
      class="modal fade"
      style="background: rgba(0, 0, 0, 0.5)"
      v-bind:class="{ show: isOpen }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="display: flex; justify-content: center"
      >
        <div
          v-if="isOpen"
          class="modal-content"
          v-click-outside="closeModal"
          id="modal"
        >
          <div class="card-body">
            <h5
              class="mx-0 px-2 pb-3 mb-0"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              {{ $t("buy_things") }}
            </h5>

            <p class="p-2 gray6" style="font-size: 1rem">
              {{ $t("pls_fill") }}
            </p>
            <form class="p-2" @submit.prevent="">
              <div class="form-group">
                <label class="gray6">{{ $t("num_of_units") }}</label>
                <input
                  type="number"
                  name="unitNum"
                  v-model="unitNum"
                  class="form-control"
                  required
                  placeholder="Enter number of units"
                  v-on:keypress="isNumber($event)"
                />
                <p class="font-12 gray5 font-bold">
                  {{ $t("price_unit") }} &#8358;{{ this.unitPrice }}.
                  {{ $t("d_sum") }} &#8358;{{ this.amount.toLocaleString() }}
                  {{ $t("wil_b_deduc") }}
                </p>
              </div>

              <div
                class="form-group mt-10"
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 4rem;
                "
              >
                <button
                  @click="closeModal"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{ $t("cancel") }}
                </button>
                <button
                  type="submit"
                  class="btn btn-primary"
                  v-if="unitNum < 1"
                >
                  {{ $t("paystack") }}
                </button>
                <paystack
                  v-else
                  :amount="amount * 100"
                  :email="email"
                  :paystackkey="public_key"
                  :reference="ref"
                  :callback="processPayment"
                  :close="close"
                  class="btn btn-primary"
                >
                  {{ $t("paystack") }}
                </paystack>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb">
      <h6 class="font-weight-bold font-14 pl-3 mb-0">{{ $t("wallet") }}</h6>
    </div>
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid mt-1">
      <!-- <div class="succeed container-fluid" v-if="mssg !== ''">
        <p>Notification!</p>
        <p class="mb-2">{{ mssg }}</p>
      </div>
      <div class="errorMsg container-fluid" v-if="Errormssg !== ''">
        <p>Notification!</p>
        <p class="mb-2">{{ Errormssg }}</p>
      </div> -->
      <!-- <NotifcationBox :mssg="mssg" :errorMssg="Errormssg" /> -->

      <div class="page-breadcrumb mb-2 pl-3 pt-0">
        <div class="row">
          <div class="col-md-8 col-lg-8 align-self-center">
            <ul class="breadcrumb mb-2 list-style-none">
              <li
                class="breadcrumb-item h6 font-14 mylink"
                style="margin-right: 3rem"
              >
                <router-link class="mylink" to="overview">{{
                  $t("overview")
                }}</router-link>
              </li>
              <li
                class="breadcrumb-item h6 font-14 mylink"
                style="margin-right: 3rem"
              >
                <router-link class="mylink" to="settings">{{
                  $t("settings")
                }}</router-link>
              </li>
            </ul>
          </div>
          <div class="col-md-4">
            <div class="d-flex align-items-center justify-content-end">
              <button
                data-step="1"
                data-intro="<h5 style='margin-bottom: 1rem; color: #213e7a'>Users</h5>Assign members of your team to monitor selected devices."
                @click="openModal"
                class="btn btn-primary"
              >
                {{ $t("buy_things") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <router-view />
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- footer -->
    <!-- ============================================================== -->
    <!-- <footer class="footer text-center">
        All Rights Reserved by Gricd Frij.
      </footer> -->
    <!-- ============================================================== -->
    <!-- End footer -->
    <!-- ============================================================== -->
  </div>
</template>

<script>
// import Vue from 'vue';
// import {mapGetters, mapActions} from 'vuex';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import paystack from "vue-paystack";
import { mapActions, mapGetters } from "vuex";
import NotifcationBox from "../../components/NotificationBox.vue";
// import vClickOutside from 'v-click-outside';
// import store from '../../store/index';

export default {
  name: "Wallet",
  data() {
    return {
      isLoading: false,
      fullPage: true,
      isOpen: false,
      mssg: "",
      unitNum: null,
      amount: 0,
      full_name: "",
      email: "",
      Errormssg: "",
      public_key: "",
      ref: "",
      unitPrice: null,
    };
  },
  components: {
    Loading,
    paystack,
    NotifcationBox,
  },
  methods: {
    ...mapActions([
      "purchaseSms",
      "updateMsg",
      "getpurchasehistory",
      "getsmsunits",
      "getwalletdetails",
      "getGricdStore",
    ]),
    closeModal() {
      this.isOpen = false;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    processPayment() {
      // window.alert('Payment recieved');
      this.isLoading = true;
      this.purchaseSms({
        paystackReference: this.ref,
        units: +this.unitNum,
        companyId: this.profile.company._id,
        amount: this.amount,
      })
        .then(() => {
          this.getpurchasehistory().then(() => {
            this.isLoading = false;
          });
          this.getsmsunits().then(() => {});
          // this.getwalletdetails().then(() => {});
          this.$router.push("/wallet/overview");

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          const errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          this.Errormssg = errormssg;
          // console.log(this.Errormssg);
          setTimeout(() => {
            this.Errormssg = "";
          }, 7000);

          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    close() {
      // console.log('close');
    },
    openModal() {
      this.isOpen = true;
      this.reference();
      this.unitNum = null;
    },
    reference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      this.ref = text;
      // return text;
    },
  },
  computed: {
    ...mapGetters([
      "profile",
      "smsNotification",
      "getWalletErrMsg",
      "gricdStore",
      "smsUnits",
    ]),
  },
  mounted() {
    this.unitPrice = this.smsUnits.pricePerUnit;
    this.email = this.profile.email;
    this.full_name = this.profile.fullname;
    if (window.location.host === "enterprise.figorr.com") {
      this.public_key = process.env.VUE_APP_LIVEKEY;
    } else this.public_key = process.env.VUE_APP_TESTKEY;
    this.updateMsg("");
  },
  watch: {
    smsNotification: {
      handler: function () {
        this.mssg = this.smsNotification;
      },
    },
    getWalletErrMsg: {
      handler: function () {
        this.Errormssg = this.getWalletErrMsg;
        // console.log(this.Errormssg);
      },
    },
    unitNum: {
      handler: function () {
        this.amount = this.unitNum * this.unitPrice;
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== "SubscriptionDevices") {
      this.$emit("hideWallet");
    }
    next();
  },
};
</script>

<style src="../../assets/css/style.css"></style>
<style scoped>
.mylink {
  color: #213e7a !important;
  font-size: 14px !important;
  text-decoration-color: #213e7a !important;
}
.mylink :hover {
  color: #213e7a !important;
  text-decoration: underline;
  text-underline-offset: 5px;
  text-decoration-color: #213e7a !important;
}
.router-link-exact-active.router-link-active {
  text-decoration: underline !important;
  color: #213e7a !important;
  cursor: default;
  text-underline-offset: 5px;
}
.succeed {
  background: #dee2eb;
  padding: 10px 15px 1px;
  border: 1px solid #213e7a;
  margin-bottom: 2rem;
}
.succeed p {
  color: #213e7a;
}
.errorMsg {
  background: #f8e2ea;
  padding: 10px 15px 1px;
  border: 1px solid #a8286f;
  margin-bottom: 2rem;
}
.errorMsg p {
  color: #a8286f;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
<i18n>
{
	"en": {
		"buy_things": "Buy Units",
		"d_sum": "The sum of",
		"details": "Details",
		"hist": "History",
		"num_of_units": "Number of Units for SMS",
		"paystack": "Pay with Paystack",
		"pls_fill": "Please fill in the number of units you will require per time.",
		"price_unit": "Price per Unit",
		"wallet": "Wallet",
		"wil_b_deduc": "will be deducted from your account"
	},
	"es": {
		"buy_things": "Comprar unidades",
		"d_sum": "La suma de",
		"details": "Detalles",
		"hist": "historia",
		"num_of_units": "Número de unidades para SMS",
		"paystack": "Paga con Paystack",
		"pls_fill": "Por favor, complete la cantidad de unidades que necesitará por vez.",
		"price_unit": "precio por unidad",
		"wallet": "billetera",
		"wil_b_deduc": "será deducido de su cuenta"
	},
	"fr": {
		"buy_things": "Acheter des unités",
		"d_sum": "La somme de",
		"details": "Détails",
		"hist": "L'histoire",
		"num_of_units": "Nombre d'unités pour SMS",
		"paystack": "Payer avec Paystack",
		"pls_fill": "Veuillez indiquer le nombre d'unités dont vous aurez besoin par fois.",
		"price_unit": "Prix par unité",
		"wallet": "Portefeuille",
		"wil_b_deduc": "sera déduit de votre compte"
	},
	"sw": {
		"buy_things": "Nunua Vitengo",
		"d_sum": "Jumla ya",
		"details": "Maelezo",
		"hist": "Historia",
		"num_of_units": "Idadi ya Vitengo vya SMS",
		"paystack": "Lipa kwa Paystack",
		"pls_fill": "Tafadhali jaza idadi ya vitengo utakavyohitaji kwa wakati.",
		"price_unit": "Bei kwa kila Kitengo",
		"wallet": "Mkoba",
		"wil_b_deduc": "itakatwa kutoka kwa akaunti yako"
	}
}
</i18n>
